import { Link } from 'react-router';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { useDismiss } from 'src/hooks/use-dismiss';
import { serviceNavItems } from 'src/layouts/nav-config';
import { mergeClasses } from 'src/utils/merge-classes';

type ServicesMenuProps = {
  open: boolean;
  onToggle: () => void;
  onClose: () => void;
};

export function ServicesMenu({ open, onClose, onToggle }: ServicesMenuProps) {
  const { t } = useTranslation('navigation');
  const ref = useDismiss<HTMLLIElement>(open, onClose);

  const handleToggle = useCallback(() => {
    onToggle();
  }, [onToggle]);

  return (
    <li ref={ref} className={mergeClasses('has-dropdown', open && 'open')}>
      <button type="button" aria-haspopup="true" aria-expanded={open} onClick={handleToggle}>
        {t('services')}
        <svg
          width="12"
          fill="none"
          height="12"
          strokeWidth="2.5"
          aria-hidden="true"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M6 9l6 6 6-6" />
        </svg>
      </button>
      <ul className="dropdown">
        {serviceNavItems.map((item) => (
          <li key={item.key}>
            <Link to={item.path}>
              <strong>{t(`servicesMenu.${item.key}.title`)}</strong>
              <small>{t(`servicesMenu.${item.key}.description`)}</small>
            </Link>
          </li>
        ))}
      </ul>
    </li>
  );
}
